import { render } from "./index.vue?vue&type=template&id=16f9cc1a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=16f9cc1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\11710\\Desktop\\admin-box-vue-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f9cc1a"]])

export default __exports__